import React, { Component } from 'react';

import { s3CacheUrl } from '../Common/util';

export class PenderQuote extends Component {
  render() {
    return(
      <div className={"collabs-banner-quote pender-fg tile is-5"}>
        {`“Discovery through process is an approach that I use both in my work and in my teaching. One must be open to what could happen and observe novel possibilities.”`}
        <div className={"collabs-banner-byline"}>
          —Stefanie Pender
        </div>
      </div>
    );
  }
}

export class PenderBio extends Component {
  render() {
    return(
      <div className={"collabs-bio"}>
        <div className={"collabs-divider pender-bg"} />

        <div className={"collabs-section white white tile is-ancestor"}>
          <div className={'collabs-bio-image-container tile is-5'}>
            <img className={"collabs-bio-image"} alt={"Stefanie Pender"} src={s3CacheUrl("https://s3.amazonaws.com/weft-public-assets/images/weft-shop-collab/pender/pender1weft-artist-portrait-388x350.jpg", 350)} />
          </div>
          <div className={"collabs-bio-header tile is-5"}>
            <h1>Hand and the Machine</h1>
            <p>The interplay between analogue craft and automated technology informs Stefanie Pender’s sculptural, mixed-media works.</p>
          </div>
        </div>

        <div className={"collabs-section grey"}>
          <div className={"bio-content"}>
            <p>As both an artist and a researcher, Pender is fascinated by the exchange between human and machine. 
            She explains, “My efforts have demonstrated that collaborative robotic fabrication shares 
            elements of acquired skill, similar to analogue fabrication.” For example, a 
            human operating a machine hones his or her technique over time, constantly learning 
            and adapting through experience. Pender’s work seeks to explore this relationship; 
            it’s what she calls, “Having a dialogue with material.” Pender is also interested 
            in how chance figures into material creation, noting, “Physical properties of material 
            that are discovered through chance, accident, or through a expertise control of 
            parameters are extremely compelling to me.”</p>
 
            <p>Her collaboration with Weft encapsulates both areas of interest; it’s informed 
            by her recent <a href={"http://www.stefaniepender.com/projects/glass-fused-deposition-modeling/1"}>Glass Fused Modeling Deposition</a> project. 
            She notes, “When I was approached to create a glass piece that could be translated to a textile design, 
            it seemed like such a natural process. I was incorrect in this assumption. 
            It was an incredible challenge.” She continues, “Although the glass pieces 
            look like a textile, that doesn't necessarily mean that there will be a one-to 
            one translation to a textile. The optical quality of the glass, such as reflection, 
            transparency and refraction made it difficult for a direct translation because 
            there wasn't any contrast between the foreground and background. We had to devise 
            a strategy to frame the sewing machine patterns of the glass against a contrasting 
            background.” The translation of these glass forms into a woven jacquard fabric 
            is yet another extension of her ongoing investigation between human, machine and material.</p>
          </div>
        </div>
      </div>
    );
  }
}